import route from './route';

export const routePermissions = {
  [route.dashboard]: 'anlytics',
  [route.updates]: 'update',
  [route.addupdate]: 'add_update',
  [route.editupdate]: 'update_edit',
  [route.news]: 'news',
  [route.addnews]: 'add_news',
  [route.editnews]: 'news_edit',
  [route.spots]: 'spot',
  [route.addspot]: 'add_spot',
  [route.editspot]: 'spot_edit',
  [route.livelist]: 'live',
  [route.livesummary]: 'view_history',
  [route.managerates]: 'rate',
  [route.survey]: 'survey',
  [route.editsurvey]: 'survey',
  [route.surveyresults]: 'survey',
  [route.surveyAnalytics]: 'survey_anlytics',
  [route.manageads]: 'ads',
  [route.editad]: 'ads',
  [route.userslist]: 'userlist',
  [route.edituser]: 'user_view',
  [route.visitors]: 'visitors',
  [route.stallBookings]: 'stall_bookings',
  [route.printSticker]: 'print_sticker',
  [route.subscriptionUsers]: 'subscription_users',
  [route.subscriptionPlans]: 'subscription_plans',
  [route.managefeedback]: 'feedback',
  [route.liveproducts]: 'live_products',
  [route.rateproducts]: 'rate_products',
  [route.products]: 'live_products',
  [route.addproduct]: 'live_products',
  [route.editproduct]: 'live_products',
  [route.brokers]: 'brokers',
  [route.addbroker]: 'brokers',
  [route.editbroker]: 'brokers',
  [route.commodity]: 'commodity',
  [route.addcommodity]: 'commodity',
  [route.editcommodity]: 'commodity',
  [route.subcommodity]: 'sub_commodity',
  [route.addsubcommodity]: 'sub_commodity',
  [route.editsubcommodity]: 'sub_commodity',
  [route.masterlanguages]: 'manage_languages',
  [route.subscriptionSettings]: 'subscription_settings',
  [route.backofficeusers]: 'employees',
  [route.masterroles]: 'manage_roles',
  [route.manageroleaccess]: 'manage_role_access',
  [route.editpermissions]: 'manage_role_access',
  [route.settings]: 'profile',
  [route.masterroutes]: 'configuration',
  [route.masterrepo]: 'configuration',
  [route.configuration]: 'configuration',
};

export const getRoutePermission = (path) => routePermissions[path] || null;
